import { http } from '@/shared/api/api-client';

import type {
  CustomerLimitState,
  PurchaseLimit,
  PurchaseLimitImpact,
  PurchaseLimitInput,
  PurchaseLimitSaved,
} from '../types/purchase-limit.types';

/**
 * Customer purchase limits (D-20) — the limits checkout enforces before any
 * money moves. Read with customers.read; changed with customers.limits.manage.
 */

export async function getPurchaseLimits(
  params: { countryId?: number; includeInactive: boolean },
  signal?: AbortSignal,
): Promise<PurchaseLimit[]> {
  return http.get<PurchaseLimit[]>('/admin/purchase-limits', { params, signal });
}

export async function getCustomerLimits(
  customerId: number,
  signal?: AbortSignal,
): Promise<CustomerLimitState[]> {
  return http.get<CustomerLimitState[]>(`/admin/customers/${customerId}/purchase-limits`, {
    signal,
  });
}

/** Dry run: who the limit would already hold back. */
export async function getPurchaseLimitImpact(
  input: PurchaseLimitInput,
): Promise<PurchaseLimitImpact> {
  return http.post<PurchaseLimitImpact>('/admin/purchase-limits/impact', input);
}

export async function createPurchaseLimit(input: PurchaseLimitInput): Promise<PurchaseLimitSaved> {
  return http.post<PurchaseLimitSaved>('/admin/purchase-limits', input);
}

export async function updatePurchaseLimit(
  id: number,
  input: { maxAmount: number; periodDays: number; reason: string },
): Promise<PurchaseLimitSaved> {
  return http.put<PurchaseLimitSaved>(`/admin/purchase-limits/${id}`, input);
}

export async function setPurchaseLimitStatus(id: number, isActive: boolean, reason: string) {
  return http.post<{ changed: number }>(`/admin/purchase-limits/${id}/status`, {
    isActive,
    reason,
  });
}
